import { Input, Tab, Form } from 'semantic-ui-react';
import { userLanguage } from '../../../app/common/userLanguageSchema/userLanguage';
import { useStore } from '../../../app/stores/store';
//import commonStore from "../../../app/stores/commonStore";

// show dummy disabled
function TabDummy() {
  const { commonStore } = useStore();
  const showdummypane = [
    {
      menuItem: 'Film',
      render: () => (
        <Tab.Pane style={{ height: '20vh' }}>
          <Form>
            <Form.Field
              fluid
              id="original_title"
              control={Input}
              label={
                (
                  userLanguage[0].Level3InventoryRecievingVerify?.IRVL03 as any
                )?.[`${commonStore.language.key}`]
              } //"Elements"
              icon="file outline"
            />
          </Form>
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div
      style={{
        pointerEvents: 'none',
        opacity: '0.33',
        minHeight: '500px',
      }}
    >
      <Tab panes={showdummypane} />
    </div>
  );
}
export { TabDummy };
